import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  menuBtn: {
    minWidth: 'auto',
    marginRight: 10,
    padding: 3,
    background: 'transparent',
    borderRadius: '50%',
  },
  menuIcon: {
    fontSize: '1.4rem',
    color: '#fff',
  },
  maxHeight: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  mobileMenuList: {
    padding: 0,
  },
  mobileMenuPaper: {
    width: '100%',
    maxWidth: '100%',
    borderRadius: 0,
    boxShadow: '0px 3px 6px rgba(0, 0, 0, .29)',
  },
  topBarWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: theme.custom.darkBlue,
  },
  meterReadingPage: {
    overflow: 'visible',
  },
}));
